module.exports = __webpack_public_path__ + "img/step-4-3-en.cfa4c896.png";